import { Component, inject } from '@angular/core';
import { LoggerService } from '../../core/logging/logger.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-prelogin',
  imports: [RouterOutlet],
  standalone: true,
  templateUrl: './pre-login.html',
  styleUrls: ['./pre-login.css'],
})
export class PreloginComponent {
  private readonly logger = inject(LoggerService);

  ngOnInit(): void {
    this.logger.debug('PreloginComponent', 'Public page layout initialized');
  }
}